import axios from "axios";

export const getInvoicesByStatus = async (status) => {
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';

  const config = {
    method: "GET",
    url: `http://${url}:4000/api/v1/boletaDigital/getInvoicesByStatus?status=${status}`,
    //url: `http://localhost:4000/api/v1/boletaDigital/getInvoicesByStatus?status=${status}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
